import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from "../../../assets/icons/close.svg";
import APIVariables from "../../../services/api-variables";
import { handleCatch, isObject } from "../../../shared/helpers";
import { App } from "../../../routes/Constants";
import QuitModal from "../../common/Modal/QuitModal";
import Loader from "../../common/Loader/Loader";
import { errorMessages } from "../../../constants/errorMessages.constants";
import RemoveOutpatientModal from "./modals/RemoveOutpatient";
import Axios from "../../../services/Axios";

const inputStyles =
  "mt-2.5 mb-[15px] w-full border-0 border-b border-[#c8c8c8] bg-[#f8f8f8] px-0 py-1 text-lg leading-[22px] text-[#646464] outline-none disabled:cursor-not-allowed";

const OutpatientEdit = () => {
  const navigate = useNavigate();

  const selectedOutpatient = window.location.pathname.split("/")[2];
  const [form, setForm] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [quitModalIsOpen, setIsOpenQuit] = useState(false);
  const [modalIsOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    getData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getData = async () => {
    await Axios.get(
      APIVariables.HCP_OUTPATIENT + window.location.pathname.split("/")[2]
    )
      .then((res) => {
        const { status, data } = res;
        if (status === 200) {
          setForm(data);
        }
      })
      .catch((error) => {
        handleCatch(error);
      });

    setIsLoading(false);
  };

  function closeForm() {
    setIsOpenQuit(true);
  }

  function closeModalQuit() {
    setIsOpenQuit(false);
  }

  function quitModal() {
    navigate(App.CONNECTED_OUTPATIENT);
  }

  const openModalRemoveOutpatient = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  const removeOutpatient = async () => {
    setErrorMessage("");

    await Axios.delete(APIVariables.HCP_OUTPATIENT_DELETE + selectedOutpatient)
      .then((res) => {
        const { status } = res;
        if (status === 200) {
          closeModal();
          navigate(App.CONNECTED_OUTPATIENT);
        }
      })
      .catch(function (error) {
        const errors = error.response.data;
        if (typeof errors === "string") {
          setErrorMessage([errorMessages.INTERNAL_SERVER_ERROR]);
        } else {
          const errorsArray = [];
          Object.keys(errors).forEach((key) => {
            if (isObject(errors[key])) {
              Object.keys(errors[key]).forEach((secondKey) => {
                errorsArray.push(key + " - " + errors[key][secondKey][0]);
              });
            } else {
              errorsArray.push(key + " - " + errors[key]);
            }
          });
          setErrorMessage(errorsArray);
        }
      });
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  if (isLoading) return <Loader />;

  return (
    <div
      className="min-h-screen overflow-y-auto  pt-[140px] pb-[100px]"
      data-testid="connected-outpatients-edit-page"
    >
      <div className="relative mx-auto max-w-[1100px] rounded-[10px] bg-white px-6 py-5 shadow-[0px_0px_40px_rgba(0,0,0,0.2)] sm:px-10">
        <button
          type="button"
          className="absolute right-[15px] top-[15px] cursor-pointer rounded-full bg-[#9ABDB8] p-[3px]"
          onClick={closeForm}
          aria-label="Close form"
          data-testid="connected-outpatients-edit-close-button"
        >
          <img src={CloseIcon} alt="" className="brightness-0 invert" />
        </button>

        <div className="flex flex-wrap items-center justify-between gap-3 pr-10">
          <h1 className="select-category-txt mineShaft-color mt-2.5 pb-1.5">
            {form?.name} - Outpatient
          </h1>
          <button
            type="button"
            className="second-button red-button"
            onClick={(e) => openModalRemoveOutpatient(e)}
            data-testid="connected-outpatients-edit-remove-button"
          >
            Remove
          </button>
        </div>
        <hr className="my-0 h-px border-0 bg-[#768692]" />

        <h2 className="title-details mineShaft-color mt-[30px] mb-[25px]">
          Outpatient Pharmacy Details
        </h2>

        <div className="mb-5">
          <div className="grid gap-4 md:grid-cols-2">
            <div>
              <label className="blue-label" htmlFor="outpatient-name">
                Outpatient Pharmacy Name:
              </label>
              <input
                id="outpatient-name"
                type="text"
                name="name"
                value={form?.name || ""}
                maxLength={30}
                disabled
                className={inputStyles}
                data-testid="connected-outpatients-edit-name-input"
              />
            </div>
            <div>
              <label className="blue-label" htmlFor="outpatient-postcode">
                Postcode:
              </label>
              <input
                id="outpatient-postcode"
                type="text"
                name="postcode"
                value={form?.postcode || ""}
                maxLength={30}
                disabled
                className={inputStyles}
                data-testid="connected-outpatients-edit-postcode-input"
              />
            </div>
          </div>
          <div className="mt-4">
            <label className="blue-label" htmlFor="outpatient-address">
              Outpatient Address:
            </label>
            <input
              id="outpatient-address"
              type="text"
              name="address"
              value={form?.address || ""}
              disabled
              className={inputStyles}
              data-testid="connected-outpatients-edit-address-input"
            />
          </div>
          <p className="info_nurse font-size-16 mt-9 leading-[15px] blue-label">
            <b className="font-size-16">IMPORTANT</b>: Connected Outpatient Pharmacy
            will only receive an email of any PAF that has been sent.
          </p>
        </div>
      </div>

      {quitModalIsOpen && (
        <QuitModal
          quitModalIsOpen={quitModalIsOpen}
          closeModalQuit={closeModalQuit}
          quitModal={quitModal}
          description="Are you sure you want to cancel filling out this form? All progress will be lost and you will need to start again."
        />
      )}

      {modalIsOpen && (
        <RemoveOutpatientModal
          modalIsOpen={modalIsOpen}
          closeModal={closeModal}
          removeOutpatient={removeOutpatient}
          errorMessage={errorMessage}
        />
      )}
    </div>
  );
};
export default OutpatientEdit;
